import { AnyAction } from 'redux';
import { SHOW_LOADING } from '../action-types';

export type ShowLoading = () => AnyAction;
export const showLoadingAction: ShowLoading = () => ({
    type: SHOW_LOADING,
});
